<template>
  <TheSearch
    :responsiveColTheSearch="responsiveColTheSearch"
    :theSearchResponsiveColDestination="theSearchResponsiveColDestination"
    :destinationPageResponsiveColPost="destinationPageResponsiveColPost"
    searchType="destinations"
    ref="theSearchFromHome"
  ></TheSearch>
</template>

<script>
import TheSearch from "../search/components/TheSearch";

export default {
  components: {
    TheSearch,
  },
  props: {
    kilometers: {
      type: [String, Number],
      default: () => NaN,
    },
  },
  data() {
    return {
      responsiveColTheSearch: {
        posts: {
          lg: 6,
          md: 6,
          sm: 12,
        },
        map: {
          lg: 6,
          md: 6,
          sm: 12,
        },
      },
    };
  },
  methods: {},
  computed: {
    theSearchResponsiveColDestination() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
        case "md":
        case "sm":
          return "6";
        case "xs":
        default:
          return "12";
      }
    },
    destinationPageResponsiveColPost() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
          return "4";
        case "lg":
        case "sm":
        case "md":
          return "6";
        case "xs":
        default:
          return "12";
      }
    },
  },
  mounted() {
    if (
      parseInt(this.kilometers) &&
      parseInt(this.kilometers) <= 200 &&
      parseInt(this.kilometers) > 0
    ) {
      this.$refs.theSearchFromHome.$refs.searchLocationAutocomplete.searchNavigatorLocationAround(
        this.kilometers
      );
    }
  },
};
</script>
<style scoped>
.scoped--home--screen {
  height: calc(100vh - 64px);
  min-height: 500px;
}
.scoped--home--screen--illustration {
  height: 50vh;
  min-height: 350px;
}
</style>
